import { render } from "./updateArticle.vue?vue&type=template&id=6240c5f0&scoped=true&ts=true"
import script from "./updateArticle.vue?vue&type=script&lang=ts"
export * from "./updateArticle.vue?vue&type=script&lang=ts"

import "./updateArticle.vue?vue&type=style&index=0&id=6240c5f0&lang=scss&scoped=true"
import "./updateArticle.vue?vue&type=style&index=1&id=6240c5f0&lang=scss"

import exportComponent from "E:\\project\\help-center\\help-center-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6240c5f0"]])

export default __exports__